export default "__VITE_PUBLIC_ASSET__d953116c__"